import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  

  return (
    <>
      <section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 lg:py-28">
        <div className="absolute inset-0 bg-black opacity-10"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div data-aos="fade-right"> 
              <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                Your Global Visa Solution Partner
              </h1>
              <p className="text-xl mb-8 text-blue-100 leading-relaxed">
                Professional visa consultancy services for over 40+ countries. 
                98% success rate with happy clients worldwide.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/contact'>
                <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition duration-300 shadow-lg transform hover:scale-105">
                  Start Your Application
                </button>
                </Link>
                <button 
                  onClick={openPopup}
                  className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition duration-300"
                >
                   Assessment
                </button>
              </div>
              <div className="mt-8 flex items-center space-x-6">
                <div className="text-center">
                  <div className="text-2xl font-bold">98%</div>
                  <div className="text-blue-200 text-sm">Success Rate</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold">40+</div>
                  <div className="text-blue-200 text-sm">Countries</div>
                </div>
              
              </div>
            </div>
            <div className="relative" data-aos="fade-left">
              <img 
                src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" 
                alt="Travel Visa" 
                className="rounded-2xl shadow-2xl w-full h-80 lg:h-96 object-cover"
              />
              <div className="absolute -bottom-4 -left-4 bg-white text-gray-800 p-4 rounded-xl shadow-lg">
                <div className="text-sm text-gray-600">Average Processing</div>
                <div className="text-xl font-bold text-blue-600">2-10 weeks</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Assessment Popup Modal */}
{isPopupOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
    <div className="bg-white rounded-xl max-w-sm w-full mx-auto shadow-2xl">
      {/* Header */}
      <div className="bg-blue-600 text-white rounded-t-xl p-4 text-center">
        <h3 className="text-lg font-bold">Get  Assessment</h3>
        <p className="text-blue-100 text-sm">Contact us now</p>
      </div>
      
      {/* Contact Options */}
      <div className="p-4 space-y-3">
        <a 
          href="tel:01912508966"
          className="flex items-center space-x-3 p-3 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition duration-300"
        >
          <span className="text-xl"><FontAwesomeIcon icon={faPhone}/></span>
          <div className="text-left">
            <div className="font-semibold">Call Now</div>
            <div className="text-sm"> 0191 250 8966</div>
          </div>
        </a>
        
        <a 
          href="https://wa.me/447796595487"
          className="flex items-center space-x-3 p-3 bg-green-50 text-green-700 rounded-lg hover:bg-green-100 transition duration-300"
        >
          <span className="text-xl"><FontAwesomeIcon icon={faWhatsapp}/></span>
          <div className="text-left">
            <div className="font-semibold">WhatsApp</div>
            <div className="text-sm"> 07796 595 487</div>
          </div>
        </a>
        
        <a 
          href="mailto:globalconsultancy3877@gmail.com"
          className="flex items-center space-x-3 p-3 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition duration-300"
        >
          <span className="text-xl"><FontAwesomeIcon icon={faEnvelope}/></span>
          <div className="text-left">
            <div className="font-semibold">Email Us</div>
            <div className="text-sm">globalconsultancy3877@gmail.com</div>
          </div>
        </a>         
      </div>
      
      {/* Close Button */}
      <div className="p-4 border-t">
        <button 
          onClick={closePopup}
          className="w-full py-2 text-gray-600 hover:text-gray-800 transition duration-300"
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default Hero;